import React from "react";

const Frame76 = () => {
      return(
            <div className="title-parent">
            <div className="title">
                  <b className="about">About the Course</b>
                  <div className="lorem-ipsum-is4">
                        Lorem Ipsum is simply dummy text of the printing and typesetting
                        industry. Lorem Ipsum has been the industry's standard dummy text
                        ever since the 1500s, when an unkno
                  </div>
            </div>
            <div className="button">
                  <b className="explore-now">Explore Now</b>
            </div>
            </div>
      );
};

export default Frame76;